import { DateRange } from 'react-date-range';
import { it, enUS, fr, es } from 'react-date-range/dist/locale';
import { useTranslation } from 'react-i18next';

const localeMap = {
  it: it,
  en: enUS,
  fr: fr,
  es: es,
};

export default function RangeDatePicker({ range, onChange }) {
  const { i18n } = useTranslation();
  const locale = localeMap[i18n.language] ?? it;

  const state = [
    { startDate: range?.[0] ?? new Date(), endDate: range?.[1] ?? null, key: 'selection' }
  ];

  return (
    <DateRange
      ranges={state}
      moveRangeOnFirstSelection={false}
      onChange={(item) => onChange?.([item.selection.startDate, item.selection.endDate])}
      locale={locale}
    />
  );
}
